import {Children} from 'react'
import type {ReactElement, ReactNode} from 'react'
import {Tabs} from '@/_new-code/products/flexible-web-toolkit/components/tabs'

interface CardTabsProps {
	children: ReactNode
	disableClickEvent?: boolean
	name?: string
}

export const CardTabs: React.FC<CardTabsProps> = ({
	children,
	disableClickEvent = false,
	name = '',
}) => {
	const childrenArray = Children.toArray(children) as ReactElement[]

	return (
		<Tabs
			aria-label="Card tabs"
			className="-mx-6 flex-grow"
			expanded
			isGrowable
			name={name}
			selected={0}
			tabClasses={`${
				disableClickEvent ? 'pointer-events-none cursor-default' : ''
			} text-sm p-2 pb-6 font-bold flex-grow border-r border-grey-400 last:border-r-0`}
		>
			{childrenArray}
		</Tabs>
	)
}
